const Timezones = [
    {"name": "Africa/Abidjan", "abbreviation": "GMT"},
    {"name": "Africa/Cairo", "abbreviation": "EET"},
    {"name": "Africa/Casablanca", "abbreviation": "WET"},
    {"name": "Africa/Johannesburg", "abbreviation": "SAST"},
    {"name": "Africa/Lagos", "abbreviation": "WAT"},
    {"name": "Africa/Nairobi", "abbreviation": "EAT"},
    {"name": "America/Adak", "abbreviation": "HST"},
    {"name": "America/Anchorage", "abbreviation": "AKST"},
    {"name": "America/Chicago", "abbreviation": "CST"},
    {"name": "America/Denver", "abbreviation": "MST"},
    {"name": "America/Los_Angeles", "abbreviation": "PST"},
    {"name": "America/New_York", "abbreviation": "EST"},
    {"name": "America/Sao_Paulo", "abbreviation": "BRT"},
    {"name": "America/Toronto", "abbreviation": "EST"},
    {"name": "Asia/Dubai", "abbreviation": "GST"},
    {"name": "Asia/Hong_Kong", "abbreviation": "HKT"},
    {"name": "Asia/Jakarta", "abbreviation": "WIB"},
    {"name": "Asia/Kolkata", "abbreviation": "IST"},
    {"name": "Asia/Seoul", "abbreviation": "KST"},
    {"name": "Asia/Shanghai", "abbreviation": "CST"},
    {"name": "Asia/Singapore", "abbreviation": "SGT"},
    {"name": "Asia/Tokyo", "abbreviation": "JST"},
    {"name": "Europe/Amsterdam", "abbreviation": "CET"},
    {"name": "Europe/Berlin", "abbreviation": "CET"},
    {"name": "Europe/Lisbon", "abbreviation": "WET"},
    {"name": "Europe/London", "abbreviation": "GMT"},
    {"name": "Europe/Moscow", "abbreviation": "MSK"},
    {"name": "Europe/Paris", "abbreviation": "CET"},
    {"name": "Europe/Rome", "abbreviation": "CET"},
    {"name": "Australia/Sydney", "abbreviation": "AEST"},
    {"name": "Pacific/Auckland", "abbreviation": "NZST"},
    {"name": "Pacific/Fiji", "abbreviation": "FJT"},
    {"name": "Pacific/Honolulu", "abbreviation": "HST"}
]

export default Timezones